import { render, staticRenderFns } from "./StallholderFilterGroup.vue?vue&type=template&id=4fb28435"
import script from "./StallholderFilterGroup.vue?vue&type=script&lang=js"
export * from "./StallholderFilterGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports